export const itemType = {
  string: 'string',
  file: 'file'
}
